import { CheckCircle } from "lucide-react";
import styles from "./styles.module.scss";
import { useNavigate } from "react-router-dom";
import { ActiveStepStore } from "src/store/onboarding.store";

export const AmazonAllSet = () => {
  const set = ActiveStepStore((state) => state.setStep);
  const nav = useNavigate();
  const handleNextStep = () => {
    set(2);
    nav("/");
  };

  return (
    <div className={styles.page}>
      <div className={styles.iconWrapper}>
        <CheckCircle className={styles.icon} />
      </div>

      <h1 className={styles.heading}>
        Congratulations, <br /> you’re all set!
      </h1>

      <p className={styles.subtext}>Your account is now connected</p>

      <button className={styles.cta} onClick={() => handleNextStep()}>
        GO TO DASHBOARD →
      </button>
    </div>
  );
};
